import React, { useState, useEffect } from "react";
import FeaturedBlogPost from "@/components/Shared/FeaturedBlogPost";
import BlogsContainer from "@/components/Blog/BlogsContainer";
import BlogsContent from "@/components/Blog/BlogsContent";
import DownArrowIcon from "@/assets/icons/down-arrow.svg";
import styles from "./styles.module.scss";

export default function BlogFilter({ blogs }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPublishDate, setSelectedPublishDate] = useState("");
  const [selectedSpecialism, setSelectedSpecialism] = useState("");
  const [selectedContentType, setSelectedContentType] = useState("");
  const [displayCount, setDisplayCount] = useState(9);
  const [showFeatured, setShowFeatured] = useState(false);
  const [filteredBlogs, setFilteredBlogs] = useState(blogs);
  const [isFilterSelected, setIsFilterSelected] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);

  const filterBlogs = () => {
    setFilteredBlogs(
      searchTerm !== "" && showFeatured
        ? filterBySearchTerm()
        : filterBySelect(),
    );
  };

  const filterBySearchTerm = () => {
    return blogs.filter((blog) => {
      const titleLowerCase = blog.title.toLowerCase();
      const contentLowerCase =
        typeof blog.content === "string" ? blog.content.toLowerCase() : "";

      return (
        titleLowerCase.includes(searchTerm.toLowerCase()) ||
        contentLowerCase.includes(searchTerm.toLowerCase())
      );
    });
  };

  const filterBySelect = () => {
    return blogs
      .filter((blog) =>
        selectedPublishDate
          ? blog?.publish_date === selectedPublishDate
          : true,
      )
      .filter((blog) =>
        selectedSpecialism ? blog?.specialism === selectedSpecialism : true,
      )
      .filter((blog) =>
        selectedContentType
          ? blog?.content_type === selectedContentType
          : true,
      );
  };

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handlePublishDateChange = (e) => {
    setSelectedPublishDate(e.target.value);

    setSearchTerm("");
    setIsOpen1(false);
  };

  const handleSpecialismChange = (e) => {
    setSelectedSpecialism(e.target.value);

    setSearchTerm("");
    setIsOpen2(false);
  };

  const handleContentTypeChange = (e) => {
    setSelectedContentType(e.target.value);

    setSearchTerm("");
    setIsOpen3(false);
  };

  const handleSearchClick = () => {
    setShowFeatured(true);

    setSelectedPublishDate("");
    setSelectedSpecialism("");
    setSelectedContentType("");
  };

  const resetFilters = () => {
    setSelectedPublishDate("");
    setSelectedSpecialism("");
    setSelectedContentType("");
    setSearchTerm("");
    setShowFeatured(false);
    setDisplayCount(6);
    setFilteredBlogs(blogs);
  };

  const loadMoreBlogs = () => {
    setDisplayCount((prevCount) => prevCount + 3);
  };

  useEffect(() => {
    setIsFilterSelected(
      !!selectedPublishDate ?? !!selectedSpecialism ?? !!selectedContentType,
    );
  }, [selectedPublishDate, selectedSpecialism, selectedContentType]);

  useEffect(() => {
    filterBlogs();
  }, [
    searchTerm,
    selectedPublishDate,
    selectedSpecialism,
    selectedContentType,
  ]);

  useEffect(() => {
    if (!showFeatured) {
      blogsToShow = filteredBlogs.slice(0, displayCount);
    }
  }, [displayCount, filteredBlogs, showFeatured]);

  const searchFiltered2 = filterBySearchTerm();
  let blogsToShow =
    searchTerm !== ""
      ? searchFiltered2
      : showFeatured
        ? filteredBlogs.slice(0, 1)
        : filteredBlogs.slice(0, displayCount);

  return (
    <div className={styles.BlogFilter}>
      <section id="AllNews">
        <div className="blog-container flex flex-wrap">
          <div className="filter-section bg-[#453562] p-4 sm:p-8 flex w-100 justify-between">
            <div className="flex flex-col w-90 filter-search-fileds">
              <div className="w-full">
                <input
                  type="text"
                  placeholder="Search by name..."
                  value={searchTerm}
                  onChange={handleSearchInputChange}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full searchterm"
                />

                <button
                  onClick={handleSearchClick}
                  disabled={!searchTerm}
                  className="border border-[#fff] text-[#fff] text-[20px] px-4 py-2 my-2 hover:bg-[#fff] hover:text-[#453562] block md:hidden"
                >
                  Search
                </button>
              </div>
              <div className="w-full flex justify-between space-x-4 filter-select">
                <div className="relative w-full">
                  <select
                    value={selectedSpecialism}
                    onChange={handleSpecialismChange}
                    className="w-full filter-selects"
                    onClick={() => setIsOpen2(!isOpen2)}
                  >
                    <option className="selectoptions" value="">
                      Select specialism
                    </option>
                    {Array.from(
                      new Set(
                        blogs
                          .map((blog) => blog.specialism)
                          .filter((specialism) => specialism.trim() !== ""),
                      ),
                    ).map((specialism, index) => (
                      <option key={index} value={specialism}>
                        {specialism}
                      </option>
                    ))}
                  </select>
                  {isOpen2 ? (
                    <DownArrowIcon className="arrow-icon ar-absolute" />
                  ) : (
                    <DownArrowIcon className="arrow-icon ar-absolute" />
                  )}
                </div>

                <div className="relative w-full">
                  <select
                    value={selectedContentType}
                    onChange={handleContentTypeChange}
                    className="w-full filter-selects"
                    onClick={() => setIsOpen3(!isOpen3)}
                  >
                    <option className="selectoptions" value="">
                      Select content type
                    </option>
                    {Array.from(
                      new Set(
                        blogs
                          .map((blog) => blog.content_type)
                          .filter((contentType) => contentType.trim() !== ""),
                      ),
                    ).map((contentType, index) => (
                      <option key={index} value={contentType}>
                        {contentType}
                      </option>
                    ))}
                  </select>
                  {isOpen3 ? (
                    <DownArrowIcon className="arrow-icon ar-absolute" />
                  ) : (
                    <DownArrowIcon className="arrow-icon ar-absolute" />
                  )}
                </div>

                <div className="relative w-full">
                  <select
                    value={selectedPublishDate}
                    onChange={handlePublishDateChange}
                    className="w-full filter-selects"
                    onClick={() => setIsOpen1(!isOpen1)}
                  >
                    <option className="selectoptions" value="">
                      Select publish date
                    </option>
                    {Array.from(
                      new Set(
                        blogs
                          .map((blog) => blog.publish_date)
                          .filter((publishDate) => publishDate.trim() !== ""),
                      ),
                    ).map((date, index) => (
                      <option key={index} value={date}>
                        {date}
                      </option>
                    ))}
                  </select>
                  {isOpen1 ? (
                    <DownArrowIcon className="arrow-icon ar-absolute" />
                  ) : (
                    <DownArrowIcon className="arrow-icon ar-absolute" />
                  )}
                </div>
              </div>
              <div
                className="resetfilters block md:hidden"
                onClick={resetFilters}
              >
                Reset Filters
              </div>
            </div>
            <div className="flex-col filter-search-buttons hidden md:flex">
              <button
                onClick={handleSearchClick}
                disabled={!searchTerm}
                className="border border-[#fff] text-[#fff] text-[20px] px-4 py-2 hover:bg-[#fff] hover:text-[#453562] ml-4"
              >
                Search
              </button>
              <div className="resetfilters" onClick={resetFilters}>
                Reset Filters
              </div>
            </div>
          </div>

          {isFilterSelected ||
            (!showFeatured && (
              <div className="featured-blog w-full lg:w-auto lg:flex-grow-3">
                <FeaturedBlogPost
                  blog={filteredBlogs.find((i) => !!i?.add_to_featured_blog)}
                />
              </div>
            ))}

          <div className="pb-10 featured-blog">
            {blogsToShow.length > 0 ? (
              <BlogsContent
                blogData={blogsToShow}
                style={null}
                color={"white"}
              />
            ) : (
              <div className="text-center mt-4">
                <p className="text-[#888888] text-[20px] px-4 py-2 hover:text-[#645477] rounded">
                  No Blogs Found
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {blogsToShow.length < searchFiltered2.length &&
        blogsToShow.length > 0 && (
          <div className="text-center mt-[80px]">
            <button
              className="text-[#888888] text-[20px] px-4 py-2 hover:text-[#ffffff] rounded"
              onClick={loadMoreBlogs}
            >
              Load more articles
            </button>
          </div>
        )}

      <BlogsContainer />
    </div>
  );
}
